/**
 * Create Tray Access payload
 *
 * @param visibleTo
 * @param commentAccess
 * @param visibleUsers
 * @param commentableUsers
 * @returns {{visibleTo: *, commentAccess: *, visibleUserUuids: any[]|*[], commentableUserUuids: any[]|*[]}}
 */
export function trayAccessPayload({
  visibleTo,
  commentAccess,
  visibleUsers = [],
  commentableUsers = [],
}) {
  return {
    visibleTo,
    commentAccess,
    visibleUserUuids: visibleTo === 'members' ? visibleUsers.map(user => user.uuid) : [],
    commentableUserUuids:
      commentAccess === 'specific' ? commentableUsers.map(user => user.uuid) : [],
  };
}

/**
 * Convert members to Tray Access state
 *
 * @param members
 * @returns {{visibleUsers: {uuid: *, name: *, email: *}[], commentableUsers: {uuid: *, name: *, email: *}[]}}
 */
export function membersToTrayAccessState(members = []) {
  const visibleUsers = members.map(memberToAccessUser);

  return {
    visibleUsers,
    commentableUsers: members.filter(member => member.can_comment).map(memberToAccessUser),
  };
}

/** Require at least one editor when manager access is restricted to specific people. */
export function validateManagerAccess({ managerAccess, managerUsers = [] }) {
  if (managerAccess === 'specific' && managerUsers.length === 0) {
    return { manager_user_uuids: 'Select at least one user who can edit this Tray' };
  }

  return {};
}

/**
 * Determine if a Tray Access state is valid
 *
 * @param accessPayload
 * @returns {string}
 */
export function trayAccessStateKey(accessPayload) {
  return JSON.stringify({
    visibleTo: accessPayload.visibleTo,
    commentAccess: accessPayload.commentAccess,
    visibleUserUuids: [...accessPayload.visibleUserUuids].sort(),
    commentableUserUuids: [...accessPayload.commentableUserUuids].sort(),
  });
}

/**
 * Convert member to Tray Access user
 *
 * @param member
 * @returns {{uuid: *, name: *, email: *}}
 */
function memberToAccessUser(member) {
  return {
    uuid: member.user_id,
    name: member.user_name,
    email: member.user_email,
  };
}
